<template>
  <el-card :body-style="{ padding: '0px' }">
    <img :src="template.preview || defaultPhoto" class="image" />
    <p class="name">{{ template.name }}</p>
    <el-link class="link" :href="templateUrl" type="primary">
      Personalizuj
    </el-link>
  </el-card>
</template>

<script>
export default {
  name: 'TemplateTile',
  props: {
    template: {
      required: true,
    },
    urlSuffix: {
      required: false,
      default: ''
    }
  },
  data() {
    return {
      defaultPhoto: '',
    };
  },
  computed: {
    templateUrl() {
      return `/editor/${this.template.code}${this.urlSuffix}`;
    },
  },
};
</script>

<style lang="less" scoped>
.name {
  padding: 0 5px;
}

.el-card {
  height: 100%;
  img {
    width: 100%;
    height: auto;
  }
}

.el-card__body {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.el-link.el-link--primary {
  display: inline-flex;
  font-weight: 600;
  font-size: 16px;
  text-decoration: none;
  margin: 16px;
  margin-top: auto;
}
</style>
